import { EquationSign, OperatorSignType } from '../types'

const useParseEquation = (equation: string): EquationSign[] => {
  const equationLength = equation.length
  let renderArray: EquationSign[] = []

  let counter = 0

  // eslint-disable-next-line fp/no-loops
  do {
    const equationCharacter = equation[counter]

    switch (equationCharacter) {
      // Addition
      case '+':
        renderArray = [...renderArray, { type: OperatorSignType.ADDITION, indexInEquation: counter }]
        break

      // Subtraction
      case '-':
        renderArray = [...renderArray, { type: OperatorSignType.SUBTRACTION, indexInEquation: counter }]
        break

      // Multiplication
      case '*':
        renderArray = [...renderArray, { type: OperatorSignType.MULTIPLICATION, indexInEquation: counter }]
        break

      // Division
      case '/':
        renderArray = [...renderArray, { type: OperatorSignType.DIVISION, indexInEquation: counter }]
        break

      // Equation inside Parenthesis
      case '(': {
        const remainingEquation = equation.slice(counter + 1)
        const parenthesisEquation = remainingEquation.split(')')[0]

        renderArray = [
          ...renderArray,
          { type: OperatorSignType.PARENTHESIS_EQUATION, equation: parenthesisEquation, indexInEquation: counter },
        ]

        // Increase counter to after the index of parenthesis end.
        counter = counter + 1 + parenthesisEquation.length

        break
      }

      // Power/Exponent
      case '^': {
        const powerOfIndex = counter + 1

        renderArray = [
          ...renderArray,
          { type: OperatorSignType.POWER, value: equation[powerOfIndex], indexInEquation: powerOfIndex },
        ]
        counter += 1
        break
      }

      // Square Root
      case 's': {
        const remainingEquation = equation.slice(counter + 5)
        const squareRootEquation = remainingEquation.split(')')[0]

        renderArray = [
          ...renderArray,
          { type: OperatorSignType.SQUARE_ROOT, equation: squareRootEquation, indexInEquation: counter },
        ]

        // Increase counter to after the end index of square root.
        counter = counter + 5 + squareRootEquation.length

        break
      }

      default:
        renderArray = [
          ...renderArray,
          { type: OperatorSignType.DIGIT, value: equation[counter], indexInEquation: counter },
        ]
        break
    }

    counter++
  } while (counter < equationLength)

  return renderArray
}

export default useParseEquation
